import classNames from 'classnames';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Box, { BoxProps } from 'ui-box';
import { defaultFills, Icon, majorScale, Tag } from '../../npaper';
import { IProduct, ProductType } from '../../stores';

export interface IProductThumbnailProps extends BoxProps<any> {
  children?: never;
  showSKU?: boolean;
  showName?: boolean | null;
  showThumbnail?: boolean;
  product: IProduct;
  disableLink?: boolean;
  small?: boolean;
  stacked?: boolean;
}

export const ProductThumbnail: React.FC<IProductThumbnailProps> = memo(
  ({
    showName = null,
    showThumbnail = true,
    showSKU = false,
    disableLink = false,
    product,
    small,
    stacked,
    ...props
  }) => {
    return (
      <Box
        {...(!disableLink
          ? { is: Link, to: `/products/${product.id}`, className: 'a' }
          : {})}
        {...props}
        display="flex"
        alignItems="center"
        flexDirection={stacked ? 'column' : 'row'}
      >
        {showThumbnail && (
          <Box
            width={majorScale(3)}
            height={majorScale(3)}
            display="flex"
            alignItems="center"
            justifyContent="center"
            marginRight={stacked ? 0 : majorScale(1)}
            flexShrink={0}
          >
            <Icon
              icon={
                product.type === ProductType.GOOD
                  ? 'barcode'
                  : product.type === ProductType.SERVICE
                  ? 'build'
                  : 'box'
              }
              color={defaultFills.normal[500]}
            />
          </Box>
        )}
        <Box display="flex" flexDirection="column" maxWidth="100%">
          {(showName || (showName === null && !showSKU)) && (
            <p
              className={classNames('elipsis', small && 'small')}
              style={{
                textDecoration: product.deleted_at ? 'line-through' : 'none',
              }}
            >
              {product.name}
            </p>
          )}
          {showSKU && (
            <p className={classNames('elipsis font-mono', small && 'small')}>
              <span
                style={{
                  textDecoration: product.deleted_at ? 'line-through' : 'none',
                }}
              >
                {product.sku ? product.sku : `(${product.id})`}
              </span>
            </p>
          )}
          {product.deleted_at && (
            <Tag intent="warning" small>
              <FormattedMessage defaultMessage="Archived" />
            </Tag>
          )}
        </Box>
      </Box>
    );
  }
);
